// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1dizn","loaderOuter":"PageOverlayLoader_loaderOuter__1uKF2"};